import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router'

import store from 'store'

import Auth from './Auth'

import logo from '../images/logo.png'

import AppBar from '@mui/material/AppBar'
import Divider from '@mui/material/Divider'
import DonutLarge from '@mui/icons-material/DonutLarge'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import MenuIcon from '@mui/icons-material/Menu'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'

import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
    logoBrand: {
        width: '100%',
        height: 'auto',
        maxWidth: 48,
        marginLeft: 8,
        marginRight: 8,
        position: 'relative',
        '&:hover': {
            cursor: 'pointer'
        }
    },
    logoTitle: {
        '&:hover': {
            cursor: 'pointer'
        }
    },
    toolbar: {
        minHeight: 56,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 900,
    },
    list: {
        width: '250px'
    },
    appBar: {
        '& *': {
            userSelect: 'none'
        }
    }
})

const ListItemDrawer = (props, ref) => {
    const
        _to = props.to,
        _primary = props.primary,
        _onClick = props.onClick

    const location = useLocation()

    return (
        <ListItem
            button
            to={_to}
            selected={_to === location.pathname}
            onClick={_onClick}
        >
            <ListItemIcon><DonutLarge /></ListItemIcon>
            <ListItemText primary={_primary} />
        </ListItem>
    )
}

const AppBarTop = (props, ref) => {
    const
        classes = useStyles(),
        history = useHistory()

    const
        [drawerOpen, setDrawerOpen] = useState(false),
        [username, setUserName] = useState('')

    const toggleDrawer = () => {
        setDrawerOpen(!drawerOpen)
    }

    const handleMenuHome = () => {
        history.push('/')
    }

    useEffect(() => {
        let name = null
        if (Auth.isAuthenticated())
            name = store.get('user').name

        setUserName(name ?? 'Narcan Sign Up')
    })

    return (
        <>
            <AppBar position='static' className={classes.appBar}>
                <Toolbar>
                    <IconButton edge='start' color='inherit' onClick={toggleDrawer}>
                        <MenuIcon />
                    </IconButton>
                    <img src={logo} alt='Logo' className={classes.logoBrand} onClick={handleMenuHome} />
                    <Typography className={classes.logoTitle} variant='contained' noWrap onClick={handleMenuHome}>
                        Town of Hempstead - Narcan Training Sign Up
                    </Typography>
                </Toolbar>
            </AppBar>
            <Drawer anchor='left' open={drawerOpen} onClose={toggleDrawer}>
                <div className={classes.toolbar}>{username}</div>
                <Divider />
                <List className={classes.list}>
                    <ListItemDrawer to='/' primary='Home' onClick={handleMenuHome} />
                </List>
                <Divider />
            </Drawer>
        </>
    )
}

export default AppBarTop
